<template>
    <ul class="w-full flex justify-center">
        <li v-for="tab in tabs" class="text-sm font-medium px-3">
            <a
                href="#"
                class="block py-3 px-1 border-b-2 outline-none"
                :class="{
                    'text-slate-800 border-orange-600': activeTab === tab,
                    'text-slate-600 border-orange-600 border-opacity-0':
                        activeTab !== tab,
                }"
                @click.prevent="setActiveTab(tab)"
                role="button"
            >
                {{ tab }}
            </a>
        </li>
    </ul>
</template>
<script setup>
const props = defineProps(['activeTab', 'tabs']);
const emit = defineEmits(['changeActiveTab']);

const setActiveTab = (tab) => {
    emit('changeActiveTab', tab);
};
</script>
